module.exports = __webpack_public_path__ + "img/23.68a9a624.png";